import React from "react";
import { useNavigate } from "react-router-dom";
import { sunboundPayProxy } from "@proxies";
import AutoEnroll from "./auto-enroll";


const StandAloneAutoEnrollent = () => {

    const navigate = useNavigate();

    const next = async (autoEnroll) => {
        try {
            await sunboundPayProxy.setAutoEnroll(autoEnroll);
            navigate(`/guarantor`);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <AutoEnroll label="Save" action={next} />
    );
};

export default StandAloneAutoEnrollent;